import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../Utils/Axios';

const Applications = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadApplications = async () => {
      try {
        const res = await api.get('/api/hospital/applications');
        setApplications(res.data?.applications || []);
      } catch (error) {
        setApplications([]);
      } finally {
        setLoading(false);
      }
    };

    loadApplications();
  }, []);

  return (
    <div className="col-lg-12">
      <div className="table-wrapper2">
        <div className="title-and-btn">
          <div className="title">
            <h4>Job Applications</h4>
          </div>
        </div>

        {loading ? (
          <p>Loading applications...</p>
        ) : (
          <table className="eg-table table job-list-table mb-0">
            <thead>
              <tr>
                <th>Job</th>
                <th>Applicant</th>
                <th>Email</th>
                <th>Qualification</th>
                <th>Notice Period</th>
                <th>Applied On</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {applications.length === 0 ? (
                <tr>
                  <td colSpan="7">No applications received yet.</td>
                </tr>
              ) : (
                applications.map((item) => (
                  <tr key={item._id}>
                    <td>{item.jobTitle || '-'}</td>
                    <td>{item.applicantName || '-'}</td>
                    <td>{item.applicantEmail || '-'}</td>
                    <td>{item.qualification || '-'}</td>
                    <td>{item.noticePeriod || '-'}</td>
                    <td>{item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-'}</td>
                    <td>
                      <Link
                        to={`/hospital-applications/${item._id}`}
                        className="primry-btn-2"
                        style={{
                          width: 38,
                          height: 38,
                          borderRadius: '50%',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: 0,
                        }}
                        title="View Full Application"
                      >
                        <i className="bi bi-eye-fill" />
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Applications;
